import styles from './modalWindow.module.scss';
import { ReactComponent as CloseIcon } from '../../images/close.svg';
import { useEffect } from "react";
import ReactDOM from "react-dom";

type ModalWindowProps = {
  children: string | JSX.Element | JSX.Element[];
  title: string;
  onClose: () => void;
  width: number;
  showTooltip?: boolean;
}

export const ModalWindow = ({ children, title, onClose, width, showTooltip }: ModalWindowProps) => {

  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);

    return () => {
      window.removeEventListener('keydown', onKeyPress);
    }
  }, []);

  const onKeyPress = (e: KeyboardEvent): void => {
    if (e.key === "Escape") {
      onClose();
    }
  }

  return ReactDOM.createPortal(
    <div className={styles.container}>
      <div className={styles.bodyContainer}>
        <div className={styles.header}></div>
        <div className={styles.body} style={{ width }}>
          <div className={styles.title}>
            <span title={!!showTooltip ? title : undefined}>{title}</span>
            <CloseIcon onClick={onClose}/>
          </div>
          {children}
        </div>
      </div>
    </div>,
    document.body);
}